export default {"src":"/_next/static/media/points.442ba588.svg","height":24,"width":24};